/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ErrorInfo {
  /**
   * Сообщение об ошибке
   * @example Ошибка обработки объекта
   */
  message: string;

  /** Код ошибки */
  errorCode:
    | "INTERNAL_ERROR"
    | "ACCESS_DENIED"
    | "VALIDATION_ERROR"
    | "DEFAULT"
    | "AUTH_120"
    | "CERT_101"
    | "CERT_103"
    | "CERT_104"
    | "CERT_105"
    | "CERT_106"
    | "CERT_107"
    | "CERT_108"
    | "CERT_109"
    | "CERT_110"
    | "CERT_111";
}

export interface InsertUkepCertRequest {
  /** Сертификат в виде строки следующего формата: -----BEGIN CERTIFICATE-----<Base64-строка>-----END CERTIFICATE-----, или <Base64-строка>. */
  body: string;
}

export interface CreateRequestCertResponse {
  /**
   * Идентификатор запроса на сертификат
   * @format uuid
   */
  id: string;

  /**
   * Тип подписи запроса на сертификат
   * @example CERT
   */
  user_signature_type: string;
}

export interface RequestCertReq {
  /** запрос на сертификат в формате CSR */
  request_certificate_body: string;

  /** Имя ключевого контейнера, который создаётся при генерации пары ключей */
  key_container_name?: string;

  /** Уникальное имя ключевого контейнера (с типом носителя), который создаётся при генерации пары ключей */
  key_container_name_unique?: string;
}

export interface ValidationErrorInfo {
  /**
   * Дата и время генерации ошибки
   * @format date-time
   */
  timestamp: string;

  /**
   * Сообщение об ошибки
   * @example Ошибка валидации
   */
  message: string;

  /** Код ошибки */
  errorCode:
    | "INTERNAL_ERROR"
    | "ACCESS_DENIED"
    | "VALIDATION_ERROR"
    | "DEFAULT"
    | "AUTH_120"
    | "CERT_101"
    | "CERT_103"
    | "CERT_104"
    | "CERT_105"
    | "CERT_106"
    | "CERT_107"
    | "CERT_108"
    | "CERT_109"
    | "CERT_110"
    | "CERT_111";

  /** Развернутое описание ошибки/ок */
  errorDetails: Record<string, ValidationFieldInfo[]>;
}

/**
 * Объект для представления ошибки
 */
export interface ValidationFieldInfo {
  /**
   * Имя поля
   * @example accountNumber
   */
  fieldName: string;

  /**
   * Сообщение об ошибки
   * @example Неверный номер счета(длина не соответствует требованиям)
   */
  message: string;

  /**
   * Переданное не верное значение
   * @example 408178L0099910004312
   */
  rejectValue: string;
}

/**
 * Серийный номер и издатель сертификата для активации
 */
export interface ActiveCertRequest {
  /** Серийный номер сертификата */
  certSerial: string;

  /** Издатель сертификата */
  issuer: string;
}

export interface RootCertInfo {
  /** Идентификатор сертификата. Уникален в рамках одного эмитента. */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Тело сертификата в PEM-формате. */
  data: string;
}

export interface GetDelegateInfoResponse {
  /** Номер телефона делегата */
  phone?: string;

  /** Адрес электронной почты */
  email?: string;

  /** ФИО делегата */
  full_name: string;

  /** Адрес электронной почты */
  authority_signature?: string;
}

export interface ClientInfo {
  /** инн */
  inn: string;

  /** огрн */
  ogrn?: string;

  /** кпп */
  kpp?: string;

  /** полное наименование клиента */
  full_name: string;

  /** все типы подтверждения клиента, разделитель ", " */
  confirm_types: string;
}

export interface ShortCertInfo {
  /** Идентификатор сертификата. Уникален в рамках одного эмитента. */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Владелец сертификата. */
  owner: string;

  /**
   * Дата и время начала действия сертификата.
   * @format date-time
   */
  notBefore: string;

  /**
   * Дата и время окончания действия сертификата.
   * @format date-time
   */
  notAfter: string;

  /** Статус сертификата. */
  state:
    | "PENDING"
    | "ENABLE"
    | "DISABLE"
    | "REVOKE"
    | "CANCEL"
    | "SUSPEND"
    | "EXPIRED"
    | "NOT_ACTIVE";

  /** Тип сертификата (УНЭП, УКЭП). */
  type: "UNEP" | "UKEP";

  /**
   * Время установки статуса.
   * @format date-time
   */
  stateTime: string;

  /** Тело сертификата в PEM-формате. */
  data: string;

  /**
   * Дата и время окончания действия приватного ключа.
   * @format date-time
   */
  timePk?: string;

  /** ИНН организации, сотрудником которой является владелец сертификата (10 цифр), или ИНН физического лица владельца сертификата, являющегося индивидуальным предпринимателем (12 цифр).  */
  inn?: string;

  /** Для ЮЛ или ИП краткое название ЮЛ или ИП – владельца СКПЭП в соответствии с ЕГРЮЛ или ЕГРИП. */
  organization?: string;

  /** Должность владельца СКПЭП для ЮЛ, "Индивидуальный предприниматель" - для ИП. */
  position?: string;
}

export interface CertificateData {
  /** Тело сертификата в PEM-формате. */
  data: string;
}

export interface FullCertInfo {
  /** Идентификатор сертификата. Уникален в рамках одного эмитента. */
  serial: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** Владелец сертификата. */
  owner: string;

  /**
   * Дата и время начала действия сертификата.
   * @format date-time
   */
  notBefore: string;

  /**
   * Дата и время окончания действия сертификата.
   * @format date-time
   */
  notAfter: string;

  /** Статус сертификата. */
  state:
    | "PENDING"
    | "ENABLE"
    | "DISABLE"
    | "REVOKE"
    | "CANCEL"
    | "SUSPEND"
    | "EXPIRED"
    | "NOT_ACTIVE";

  /** Тип сертификата (УНЭП, УКЭП). */
  type: "UNEP" | "UKEP";

  /**
   * Время установки статуса.
   * @format date-time
   */
  stateTime: string;

  /** Тело сертификата в PEM-формате. */
  data: string;

  /**
   * Дата и время окончания действия приватного ключа.
   * @format date-time
   */
  timePk?: string;

  /** ИНН организации, сотрудником которой является владелец сертификата (10 цифр), или ИНН физического лица владельца сертификата, являющегося индивидуальным предпринимателем (12 цифр).  */
  inn?: string;

  /** Для ЮЛ или ИП краткое название ЮЛ или ИП – владельца СКПЭП в соответствии с ЕГРЮЛ или ЕГРИП. */
  organization?: string;

  /** Должность владельца СКПЭП для ЮЛ, "Индивидуальный предприниматель" - для ИП. */
  position?: string;

  /** Идентификатор клиента в АБС, к которому принадлежит пользователь, которому принадлежит сертификат. */
  clientAbsId: string;

  /** Идентификатор филиала в АБС, к которому принадлежит клиент. */
  clientBranchAbsId: string;

  /** Идентификатор пользователя в АБС, которому принадлежит сертификат. */
  userAbsId: string;
}

/**
 * содержит объекты с информацией о сертификатах
 */
export interface Certificate {
  /** Идентификатор клиента в АБС */
  clientAbsId: string;

  /** код филиала, в котором заключен договор с клиентом */
  branchAbsId: string;

  /** серийный номер сертификата */
  serial: string;

  /** наименование удостоверяющего центра */
  issuer: string;

  /** один из вариантов возвращаемых статусов сертификата: PENDING, ENABLE */
  state:
    | "PENDING"
    | "ENABLE"
    | "DISABLE"
    | "REVOKE"
    | "CANCEL"
    | "SUSPEND"
    | "EXPIRED"
    | "NOT_ACTIVE";

  /**
   * дата начала действия сертификата
   * @format date-time
   */
  beginDate: string;

  /**
   * дата окончания действия сертификата (последний день)
   * @format date-time
   */
  endDate: string;

  /** тип электронной подписи (УНЭП, УКЭП) */
  type: string;

  /** Серийный номер корневого сертификата */
  rootSerial: string;
}

export interface GetCertificateInfoResponse {
  /** содержит объекты с информацией о сертификатах */
  certificate: Certificate[];
}

export interface ShortRequestCio {
  /** Идентификатор заявки на СИО в МС */
  id: string;

  /** ФИО делегата в рамках заявки */
  fullName: string;

  /**
   * Дата создания заявки
   * @format date-time
   */
  createDate: string;

  /** Статус заявки */
  state: string;
}

export interface PdfResponse {
  /** pdf файл */
  pdf: string;
}

/**
 * Запросы на сертификаты
 */
export interface RequestCert {
  /**
   * Идентификатор запроса на сертификат в МС
   * @format uuid
   */
  id: string;

  /** Статус запроса на сертификат */
  state: "NEW" | "SENT_CA" | "EXECUTED" | "REFUSED" | "CANCELED" | "ERROR";

  /** Тип подписи запроса на сертификат */
  userSignatureType: "CERT" | "SIGN";

  /** ФИО делегата в рамках запроса */
  full_name: string;

  /**
   * Дата и время создания заявки в формате UTC (нулевой часовой пояс)
   * @format date-time
   */
  create_date: string;

  /** флаг успешности ознакомления пользователя с запросом на сертификат. Если в таблице null, возвращать false */
  user_request_certificate_confirm: boolean;
}

export interface RequestCertListResponse {
  /** Запросы на сертификаты */
  requestCerts: RequestCert[];
}

export interface RequestCertPdfResponse {
  /** pdf файл */
  pdf: string;

  /** Необходимость печати заявки на СИО для передачи в офис банка с живой подписью */
  isPrintRequired: boolean;
}

export interface RequestCertPreview {
  /** e-mail делегата */
  email?: string;

  /** страна клиента */
  country: string;

  /** Подразделение организации */
  ou?: string;

  /** краткое наименование клиента */
  client_short_name: string;

  /** ФИО делегата */
  full_name: string;

  /** идентификатор соответствующего запроса на СИО для заполнения поля T */
  t_id_ca: string;
}

export interface PossibilityIssuingCertResponse {
  /** Возможность выпуска нового сертификата */
  possibility_issuing_cert: boolean;
}

export interface CertData {
  /** Серийный номер сертификата */
  certSerial: string;

  /** Тело сертификата в base64 */
  certData: string;

  /** Статус сертификата */
  state:
    | "PENDING"
    | "ENABLE"
    | "DISABLE"
    | "REVOKE"
    | "CANCEL"
    | "SUSPEND"
    | "EXPIRED"
    | "NOT_ACTIVE";

  /**
   * Дата начала действия сертификата
   * @format date-time
   */
  notBefore: string;

  /**
   * Дата окончания действия сертификата
   * @format date-time
   */
  notAfter: string;

  /** Имя владельца из owner значение CN. "CN=КУЗБАС КИРИЛЛ ВЛАДИМИРОВИЧ" */
  fullName?: string;

  /** Короткое наименование организации из certreg_o_cert.organization */
  clientShortName?: string;

  /** Должность из owner значение OU */
  position?: string;

  /** Имя владельца из owner значение EMAILADDRESS */
  email?: string;

  /** Имя владельца из owner значение C. */
  country?: string;

  /** издатель */
  issuer?: string;

  /** открытый ключ */
  publicKey?: string;

  /** алгоритм подписи */
  sigAlgName?: string;
}

/**
 * список сертификатов
 */
export interface CertInfo {
  /** Идентификатор сертификата. Уникален в рамках одного эмитента. */
  serialCert: string;

  /** Имя эмитента сертификата (центра сертификации). */
  issuer: string;

  /** ФИО делегата из owner (CN=) */
  fullName: string;

  /**
   * Дата и время начала действия сертификата.
   * @format date-time
   */
  notBefore: string;

  /**
   * Дата и время окончания действия сертификата.
   * @format date-time
   */
  notAfter: string;

  /** Статус сертификата. */
  state:
    | "PENDING"
    | "ENABLE"
    | "DISABLE"
    | "REVOKE"
    | "CANCEL"
    | "SUSPEND"
    | "EXPIRED"
    | "NOT_ACTIVE";

  /** серийный номер корневого сертификата */
  serialRootCert: string;
}

export interface CertInfoList {
  /** список сертификатов */
  cert: CertInfo[];
}

/**
 * Активные сертификаты делегата
 */
export interface CertInfoDto {
  /** Номер сертификата */
  serial?: string;

  /**
   * Дата и время окончания действия сертификата.
   * @format date-time
   */
  notAfter?: string;

  /** Статус сертификата. */
  state?: string;
}

export interface ClientEmployeesResponse {
  /** ФИО делегата */
  fullName: string;

  /** Должность делегата */
  position?: string;

  /** Сигнатура полномочия */
  authoritySignature?: string;

  /**
   * Окончание действия сигнатуры полномочия
   * @format date-time
   */
  expireAt?: string;

  /** Активные сертификаты делегата */
  certificates?: CertInfoDto[];
}

export interface CcbResp {
  document?: Document;
  ccb?: string;
  ccbVersion?: string;
}

export interface Document {
  /** Описание документа */
  type?: DocumentType;
  fields?: DocumentFields;
}

export interface DocumentFields {
  /** идентификатор запроса на сертификат */
  id: string;

  /** тело запроса на сертификат в раскодированном виде */
  rawRequest: string;
}

/**
 * Описание документа
 */
export interface DocumentType {
  /** Название типа документа (латиницей). */
  name: string;

  /** Описание типа документа, которое может быть отображено пользователю. */
  desc: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис Управление сертификатами
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://localhost:8081
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Управление сертификатами <info@rshbintech.ru> (https://rshbintech.ru/)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name InsertUkepCertificate
     * @summary Добавление делегату сертификата УКЭП
     * @request POST:/api/certificate-registry/v1/external/qualified-certificate
     * @secure
     */
    insertUkepCertificate: (
      data: InsertUkepCertRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/qualified-certificate`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name CreateCertRequest3Az
     * @summary Создание запроса на выпуск сертификата в 3 АЗ
     * @request POST:/api/certificate-registry/v1/external/3az-create-request-cert
     * @secure
     */
    createCertRequest3Az: (data: RequestCertReq, params: RequestParams = {}) =>
      this.request<CreateRequestCertResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-create-request-cert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name CreateCertRequest2Az
     * @summary Создание запроса на выпуск сертификата в 2 АЗ
     * @request POST:/api/certificate-registry/v1/external/2az-create-request-cert
     * @secure
     */
    createCertRequest2Az: (data: RequestCertReq, params: RequestParams = {}) =>
      this.request<CreateRequestCertResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-create-request-cert`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name ChangeStateThird
     * @summary Управление запросами на сертификат 3 АЗ
     * @request PATCH:/api/certificate-registry/v1/external/3az-control-request-cert
     * @secure
     */
    changeStateThird: (
      query: {
        id: string;
        newState:
          | "NEW"
          | "SENT_CA"
          | "EXECUTED"
          | "REFUSED"
          | "CANCELED"
          | "ERROR";
      },
      params: RequestParams = {}
    ) =>
      this.request<void, ValidationErrorInfo | ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-control-request-cert`,
        method: "PATCH",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name ConfirmRequestCertThird
     * @summary Подтверждение заявки на выпуск сертификата в 3 АЗ
     * @request PATCH:/api/certificate-registry/v1/external/3az-confirm-request-cert
     * @secure
     */
    confirmRequestCertThird: (
      query: { id: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-confirm-request-cert`,
        method: "PATCH",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name ActivateCert
     * @summary Активация сертификата после подтверждения установки пользователем
     * @request PATCH:/api/certificate-registry/v1/external/3az-activate-cert
     * @secure
     */
    activateCert: (data: ActiveCertRequest, params: RequestParams = {}) =>
      this.request<void, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-activate-cert`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name ChangeStateSecond
     * @summary Управление запросами на сертификат 2 АЗ
     * @request PATCH:/api/certificate-registry/v1/external/2az-control-request-cert
     * @secure
     */
    changeStateSecond: (
      query: {
        id: string;
        newState:
          | "NEW"
          | "SENT_CA"
          | "EXECUTED"
          | "REFUSED"
          | "CANCELED"
          | "ERROR";
      },
      params: RequestParams = {}
    ) =>
      this.request<void, ValidationErrorInfo | ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-control-request-cert`,
        method: "PATCH",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name ConfirmRequestCertSecond
     * @summary Подтверждение заявки на выпуск сертификата в 2 АЗ
     * @request PATCH:/api/certificate-registry/v1/external/2az-confirm-request-cert
     * @secure
     */
    confirmRequestCertSecond: (
      query: { id: string },
      params: RequestParams = {}
    ) =>
      this.request<void, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-confirm-request-cert`,
        method: "PATCH",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name FindRootCertificate
     * @summary Получение корневого сертификата
     * @request GET:/api/certificate-registry/v1/external/root-certificate/{serial}
     * @secure
     */
    findRootCertificate: (serial: string, params: RequestParams = {}) =>
      this.request<RootCertInfo, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/root-certificate/${serial}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name FindActiveRootCertificate
     * @summary Получение активного корневого сертификата
     * @request GET:/api/certificate-registry/v1/external/root-certificate/data
     * @secure
     */
    findActiveRootCertificate: (params: RequestParams = {}) =>
      this.request<RootCertInfo, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/root-certificate/data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация
     * @name GetDelegateInfo
     * @summary Получение информации о делегате
     * @request GET:/api/certificate-registry/v1/external/delegate-info
     * @secure
     */
    getDelegateInfo: (params: RequestParams = {}) =>
      this.request<GetDelegateInfoResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/delegate-info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags client-controller
     * @name GetClientInfo
     * @summary Информация о клиенте
     * @request GET:/api/certificate-registry/v1/external/client-info
     * @secure
     */
    getClientInfo: (params: RequestParams = {}) =>
      this.request<ClientInfo, ClientInfo>({
        path: `/api/certificate-registry/v1/external/client-info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name GetUserCertificates
     * @summary Получение сертификатов текущего пользователя
     * @request GET:/api/certificate-registry/v1/external/certificate
     * @secure
     */
    getUserCertificates: (params: RequestParams = {}) =>
      this.request<ShortCertInfo[], ValidationErrorInfo>({
        path: `/api/certificate-registry/v1/external/certificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name GetCertificateData
     * @summary Получение персонального сертификата сотрудника Клиента
     * @request GET:/api/certificate-registry/v1/external/certificate/sn/data
     * @secure
     */
    getCertificateData: (
      query: { serial: string; issuer: string },
      params: RequestParams = {}
    ) =>
      this.request<CertificateData, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/certificate/sn/data`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name FindActiveCertificate
     * @summary Получение активного сертификата
     * @request GET:/api/certificate-registry/v1/external/certificate/data
     * @secure
     */
    findActiveCertificate: (params: RequestParams = {}) =>
      this.request<FullCertInfo, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/certificate/data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name GetCertificateInfo
     * @summary Информация о действующих сертификатах пользователя
     * @request GET:/api/certificate-registry/v1/external/certificate-info
     * @secure
     */
    getCertificateInfo: (params: RequestParams = {}) =>
      this.request<GetCertificateInfoResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/certificate-info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на СИО
     * @name FindRequestCioThird
     * @summary Заявки делегата на СИО для третьей авторизованной зоны (3 АЗ)
     * @request GET:/api/certificate-registry/v1/external/3az-request-cio
     * @secure
     */
    findRequestCioThird: (params: RequestParams = {}) =>
      this.request<ShortRequestCio[], ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-request-cio`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на СИО
     * @name GetRequestCioPrintById
     * @summary Печать заявки на СИО для 3 АЗ
     * @request GET:/api/certificate-registry/v1/external/3az-request-cio/{id}/print
     * @secure
     */
    getRequestCioPrintById: (id: string, params: RequestParams = {}) =>
      this.request<PdfResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-request-cio/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name RequestCertListThird
     * @summary Список запросов на сертификаты в 3 АЗ
     * @request GET:/api/certificate-registry/v1/external/3az-request-cert
     * @secure
     */
    requestCertListThird: (params: RequestParams = {}) =>
      this.request<RequestCertListResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-request-cert`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name PrintRequestCertThird
     * @summary Печать заявки на выпуск сертификата в 3 АЗ
     * @request GET:/api/certificate-registry/v1/external/3az-request-cert/{id}/print
     * @secure
     */
    printRequestCertThird: (id: string, params: RequestParams = {}) =>
      this.request<RequestCertPdfResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-request-cert/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name RequestCertPreviewThird
     * @summary Получение сведений для предзаполнения заявки на сертификат в 3 АЗ
     * @request GET:/api/certificate-registry/v1/external/3az-preview-request-cert
     * @secure
     */
    requestCertPreviewThird: (params: RequestParams = {}) =>
      this.request<RequestCertPreview, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-preview-request-cert`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name PossibilityIssuingCertThird
     * @summary Возможность выпуска нового сертификата в 3 АЗ
     * @request GET:/api/certificate-registry/v1/external/3az-possibility-issuing-cert
     * @secure
     */
    possibilityIssuingCertThird: (params: RequestParams = {}) =>
      this.request<PossibilityIssuingCertResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-possibility-issuing-cert`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name GetCertData
     * @summary Получение тела сертификата для установки пользователем
     * @request GET:/api/certificate-registry/v1/external/3az-cert
     * @secure
     */
    getCertData: (
      query: { certSerial: string; issuer: string },
      params: RequestParams = {}
    ) =>
      this.request<CertData, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-cert`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name ListCertsThird
     * @summary Список сертификатов делегата в 3 АЗ
     * @request GET:/api/certificate-registry/v1/external/3az-cert-list
     * @secure
     */
    listCertsThird: (params: RequestParams = {}) =>
      this.request<CertInfoList, CertInfoList>({
        path: `/api/certificate-registry/v1/external/3az-cert-list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name CancelCertA3
     * @summary Печать запроса на аннулирование сертификата в 3 АЗ
     * @request GET:/api/certificate-registry/v1/external/3az-cancel-cert/print
     * @secure
     */
    cancelCertA3: (
      query: { serial: string; issuer: string },
      params: RequestParams = {}
    ) =>
      this.request<PdfResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/3az-cancel-cert/print`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на СИО
     * @name FindRequestCioSecond
     * @summary Заявки делегата на СИО для второй авторизованной зоны (2 АЗ)
     * @request GET:/api/certificate-registry/v1/external/2az-request-cio
     * @secure
     */
    findRequestCioSecond: (params: RequestParams = {}) =>
      this.request<ShortRequestCio[], ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-request-cio`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на СИО
     * @name PrintRequestCioById
     * @summary Печать заявки на СИО для 2 АЗ
     * @request GET:/api/certificate-registry/v1/external/2az-request-cio/{id}/print
     * @secure
     */
    printRequestCioById: (id: string, params: RequestParams = {}) =>
      this.request<PdfResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-request-cio/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name RequestCertListSecond
     * @summary Список запросов на сертификаты в 2 АЗ
     * @request GET:/api/certificate-registry/v1/external/2az-request-cert
     * @secure
     */
    requestCertListSecond: (params: RequestParams = {}) =>
      this.request<RequestCertListResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-request-cert`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name PrintRequestCertSecond
     * @summary Печать заявки на выпуск сертификата в 2 АЗ
     * @request GET:/api/certificate-registry/v1/external/2az-request-cert/{id}/print
     * @secure
     */
    printRequestCertSecond: (id: string, params: RequestParams = {}) =>
      this.request<RequestCertPdfResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-request-cert/${id}/print`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name RequestCertPreviewSecond
     * @summary Получение сведений для предзаполнения заявки на сертификат в 2 АЗ
     * @request GET:/api/certificate-registry/v1/external/2az-preview-request-cert
     * @secure
     */
    requestCertPreviewSecond: (params: RequestParams = {}) =>
      this.request<RequestCertPreview, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-preview-request-cert`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Заявки на сертификат
     * @name PossibilityIssuingCertSecond
     * @summary Возможность выпуска нового сертификата в 2 АЗ
     * @request GET:/api/certificate-registry/v1/external/2az-possibility-issuing-cert
     * @secure
     */
    possibilityIssuingCertSecond: (params: RequestParams = {}) =>
      this.request<PossibilityIssuingCertResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-possibility-issuing-cert`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация
     * @name ClientEmployees
     * @summary Получение информация о сотрудниках Клиента во 2 АЗ
     * @request GET:/api/certificate-registry/v1/external/2az-org-delegates
     * @secure
     */
    clientEmployees: (params: RequestParams = {}) =>
      this.request<ClientEmployeesResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-org-delegates`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name ListCertsSecond
     * @summary Список сертификатов делегата в 2 АЗ
     * @request GET:/api/certificate-registry/v1/external/2az-cert-list
     * @secure
     */
    listCertsSecond: (params: RequestParams = {}) =>
      this.request<CertInfoList, CertInfoList>({
        path: `/api/certificate-registry/v1/external/2az-cert-list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ККБ
     * @name GetDocumentCcbString
     * @summary Документ и строка ККБ для подписания запроса на сертификат
     * @request GET:/api/certificate-registry/v1/external/2az-ccb
     * @secure
     */
    getDocumentCcbString: (
      query: { certificateRequestId: string },
      params: RequestParams = {}
    ) =>
      this.request<CcbResp, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Сертификат клиента
     * @name CancelCertA2
     * @summary Печать запроса на аннулирование сертификата в 2 АЗ
     * @request GET:/api/certificate-registry/v1/external/2az-cancel-cert/print
     * @secure
     */
    cancelCertA2: (
      query: { serial: string; issuer: string },
      params: RequestParams = {}
    ) =>
      this.request<PdfResponse, ErrorInfo>({
        path: `/api/certificate-registry/v1/external/2az-cancel-cert/print`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
